export enum DeleteFirebaseUserKeys {
  uid = 'uid',
}

export interface DeleteFirebaseUser {
  [DeleteFirebaseUserKeys.uid]: string;
}
